// export const home = '/';
export const businessCard = '/:id';
export const contactNotFound = '/contato-nao-encontrado';
